import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FulfillmentState = {
  dataAllFulfillment: FulfillmentType[];
  dataDetailFulfillment?: FulfillmentDetailType;
  dataWorkflowFulfillment?: FulfillmentWorkflowType;
  dataContentWorkflowFulfillment?: ContentWorkflowFulfillmentType;
  dataActivityLog: ActivityLogItem[];
  activityLogPagination: PaginationAPI;
  pagination: PaginationAPI;
  totalElements?: number;
  loading: boolean;
  dataAllAuditHistoryFulfillment?: AuditHistoryFulfillmentType[];
  isViewingStageHistory: boolean;
};

export const fulfillmentInitialState: FulfillmentState = {
  dataAllFulfillment: [],
  dataActivityLog: [],
  activityLogPagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
  isViewingStageHistory: false,
  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
  loading: false,
};

export const slice = createSlice({
  name: 'fulfillment',
  initialState: fulfillmentInitialState,
  reducers: {
    setListFulfillmentAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: FulfillmentType[];
        pagination?: PaginationAPI;
        totalElements?: number;
        append?: boolean;
      }>,
    ) {
      if (payload.append) {
        state.dataAllFulfillment = [...state.dataAllFulfillment, ...payload.data];
      } else {
        state.dataAllFulfillment = payload.data;
      }
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setFulfillmentLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setListDetailFulfillmentAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: FulfillmentDetailType;
      }>,
    ) {
      state.dataDetailFulfillment = payload.data;
    },

    setListWorkflowFulfillmentAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: FulfillmentWorkflowType;
      }>,
    ) {
      state.dataWorkflowFulfillment = payload.data;
    },

    setListContentWorkflowFulfillmentAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: ContentWorkflowFulfillmentType;
      }>,
    ) {
      state.dataContentWorkflowFulfillment = payload.data;
    },

    setActivityLogAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: ActivityLogItem[];
        pagination?: PaginationAPI;
        append?: boolean;
      }>,
    ) {
      if (payload.append) {
        state.dataActivityLog = [...state.dataActivityLog, ...payload.data];
      } else {
        state.dataActivityLog = payload.data;
      }
      state.activityLogPagination = payload.pagination || state.activityLogPagination;
    },

    clearActivityLogAction(state) {
      state.dataActivityLog = [];
      state.activityLogPagination = fulfillmentInitialState.activityLogPagination;
    },

    setListAuditHistoryFulfillmentAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: AuditHistoryFulfillmentType[];
      }>,
    ) {
      state.dataAllAuditHistoryFulfillment = payload.data;
    },

    setIsViewingStageHistoryAction(
      state,
      { payload }: PayloadAction<boolean>,
    ) {
      state.isViewingStageHistory = payload;
    },
  },
});

export const {
  setListFulfillmentAction,
  setFulfillmentLoading,
  setListDetailFulfillmentAction,
  setListWorkflowFulfillmentAction,
  setListContentWorkflowFulfillmentAction,
  setActivityLogAction,
  clearActivityLogAction,
  setListAuditHistoryFulfillmentAction,
  setIsViewingStageHistoryAction,
} = slice.actions;

export default slice.reducer;
